import React from 'react'
import ScaleLoader from "react-spinners/ScaleLoader";

const Loading = () => {
  return (
    <div className="loading">
      <ScaleLoader
        className="loader"
        color={"#1c2833"}
        size={50}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  )
}

export default Loading
